import { render, staticRenderFns } from "./dialog-shenpi.vue?vue&type=template&id=f3303932&scoped=true&"
import script from "./dialog-shenpi.vue?vue&type=script&lang=js&"
export * from "./dialog-shenpi.vue?vue&type=script&lang=js&"
import style0 from "./dialog-shenpi.vue?vue&type=style&index=0&id=f3303932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3303932",
  null
  
)

export default component.exports